export const PUBLIC_PROFILES_QUERY_KEY = 'PublicProfiles';
export const PUBLIC_PROFILE_TAGS_QUERY_KEY = 'PublicProfileTags';
